import { z } from 'zod';

export const meResponseSchema = z.object({
  name: z.string(),
  pan: z.string(),
  investorId: z.string().optional(),
  darkModeEnabled: z.boolean().nullish(),
});

export type MeResponse = z.infer<typeof meResponseSchema>;
